/*
  Neubau D · Händler-Bildrahmen (Bestellblock + Regalplaner, Lea 07.10.2026): Bilder passen sich ihrem Rahmen an.
  Freigestellte Packshots (PNG/WebP) haben in Shopify sehr unterschiedlich viel leeren Rand. Dieses Skript misst den sichtbaren
  Teil (Alpha) einmal im Browser und legt das Bild so in den Rahmen, dass genau dieser Teil --bild-fill vom Rahmen füllt
  (mittig; ist der Packshot unten angeschnitten, steht er unten bündig). Fotos mit eigenem Grund (JPG) bleiben bei der CSS-Regel.
  data-bild (foto | hoch | frei) setzt Liquid (snippets/d-b2b-bild), hier wird es für getauschte Bilder nachgezogen.
  Ohne Skript oder bei fremdem Bildserver gilt die CSS-Regel allein. Läuft einmal, auch wenn beide Ansichten es laden.
*/
(() => {
  if (window.kdB2bBild) return;
  const FRAME = '.kka-row__img, .kka-pdp__img, .kb-card__media, .kb-set__thumb, .kb-sum__thumb, .kb-pdp__plate, .kb-thumb, .kb-line__img';
  const cache = new Map();
  const canvas = document.createElement('canvas');
  const cx = canvas.getContext('2d', { willReadFrequently: true });

  const box = (img) => {
    const src = img.currentSrc || img.src;
    if (cache.has(src)) return cache.get(src);
    const k = Math.min(1, 160 / Math.max(img.naturalWidth, img.naturalHeight));
    const w = Math.max(1, Math.round(img.naturalWidth * k));
    const h = Math.max(1, Math.round(img.naturalHeight * k));
    canvas.width = w; canvas.height = h;
    cx.clearRect(0, 0, w, h);
    cx.drawImage(img, 0, 0, w, h);
    const d = cx.getImageData(0, 0, w, h).data;
    let x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        if (d[(y * w + x) * 4 + 3] > 24) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
    }
    const b = x1 < 0 ? null : { x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h };
    cache.set(src, b);
    return b;
  };

  const fit = (img) => {
    const f = img.parentElement;
    if (!f || !f.matches(FRAME) || !img.naturalWidth) return;
    const src = (img.currentSrc || img.src).split('?')[0];
    const nr = img.naturalWidth / img.naturalHeight;
    const foto = /\.jpe?g$/i.test(src);
    f.dataset.bild = foto ? 'foto' : nr < 0.8 ? 'hoch' : 'frei';
    f.classList.remove('is-fit');
    if (foto) return;
    let b;
    try { b = box(img); } catch (_) { return; } // fremder Bildserver: CSS-Regel bleibt
    if (!b) return;
    const r = f.getBoundingClientRect();
    const fa = r.width && r.height ? r.width / r.height : 1;
    const t = parseFloat(getComputedStyle(f).getPropertyValue('--bild-fill')) || 0.88;
    const bw = b.x1 - b.x0, bh = b.y1 - b.y0;
    const iw = t * Math.min(1 / bw, nr / (bh * fa)); // Bildbreite in Rahmenbreiten
    const ih = (iw / nr) * fa; // Bildhöhe in Rahmenhöhen
    const left = 0.5 - iw * (b.x0 + bw / 2);
    const top = b.y1 > 0.985 ? 1 - ih * b.y1 : 0.5 - ih * (b.y0 + bh / 2);
    f.style.setProperty('--bild-w', (iw * 100).toFixed(2) + '%');
    f.style.setProperty('--bild-x', (left * 100).toFixed(2) + '%');
    f.style.setProperty('--bild-y', (top * 100).toFixed(2) + '%');
    f.classList.add('is-fit');
  };

  const run = (root = document) => root.querySelectorAll(FRAME).forEach((f) => {
    const img = f.querySelector(':scope > img');
    if (img && img.complete && img.naturalWidth) fit(img);
  });
  document.addEventListener('load', (e) => { if (e.target.tagName === 'IMG') fit(e.target); }, true);
  run();
  window.kdB2bBild = { run };
})();
